import {Body, Head} from "./lib";
import {Fragment} from "react/jsx-runtime";
import {get} from "global/slices/payments/thunks";
import {useAppDispatch, useAppSelector} from "hooks";
import {CreditCardOutlined} from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import {TableContainer, Table as MUITable} from "@mui/material";
import {
  Loader,
  Column,
  Skeleton,
  EndMessage,
  ComponentLoader,
} from "components";

interface TableProps {}

export const Table: React.FC<TableProps> = () => {
  const dispatch = useAppDispatch();
  const {payments, request, pagination} = useAppSelector("payments");
  const {hasMore, ser} = pagination;
  const emptyMessage = ser
    ? "No se han encontrado pagos"
    : "No hay pagos registrados";

  return (
    <div style={{width: "100%"}}>
      <InfiniteScroll
        loader={<Loader />}
        hasMore={hasMore as boolean}
        dataLength={payments["length"]}
        scrollableTarget="scrollable"
        style={{marginBottom: !payments["length"] ? "1rem" : undefined}}
        next={() => dispatch(get({...pagination, pos: pagination["pos"] + 1}))}
        endMessage={
          !payments["length"] && !hasMore ? (
            <Fragment />
          ) : (
            <EndMessage icon={CreditCardOutlined} data={payments} />
          )
        }
      >
        <ComponentLoader
          requestStatus={request["payments"]}
          skeleton={
            <Column width="100%">
              <Skeleton height={60} width="100%" />
              <Column gap={2} width="100%">
                <Skeleton count={11} height={68} width="100%" />
              </Column>
            </Column>
          }
          emptyUI={{
            data: payments,
            message: emptyMessage,
            style: {width: "100%"},
            icon: CreditCardOutlined,
          }}
        >
          <TableContainer>
            <MUITable size="medium" sx={{minWidth: 750}}>
              <Head />
              <Body />
            </MUITable>
          </TableContainer>
        </ComponentLoader>
      </InfiniteScroll>
    </div>
  );
};
